import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { passwordLevel } from 'config/passwordRules';

export interface passwordStrengthProps {
  password: string;
  /** 強さの段階（0〜4）を知らせる。送れるかどうかの判定には使わない（config/passwordRules を使う）。 */
  onPasswordScoreChange?: (passwordScore: number) => void;
}

/**
 * パスワードの強さの目安（4つの棒）。
 *
 * 2026-10-26（EV-474）。以前は独自の点数（8文字以上 +1／未満 −1、数字 +1、大文字 +1、ASCII の記号 +1）で、
 * 送れるかどうかもこの点数（3以上）で決めていたため、サーバーの規則と食い違っていた（`abcdefg#` を断り、
 * `Abcdef-1` を通した）。いまは段階を規則（config/passwordRules の passwordLevel。アプリと同じ）から出し、
 * 規則をすべて満たしたときだけ4本（緑）にする。規則を満たしていないのに「強い」と見えることはない。
 */
function PasswordStrength({ password, onPasswordScoreChange }: passwordStrengthProps) {
  const { t } = useTranslation('login');
  const passwordScore = passwordLevel(password);

  useEffect(() => {
    onPasswordScoreChange?.(passwordScore);
  }, [passwordScore, onPasswordScoreChange]);

  return (
    <div className="text-right" data-testid="password-strength" data-level={passwordScore}>
      <div className="flex -mx-1">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="w-1/4 px-1">
            <div
              className={`h-1 rounded-md transition-colors ${
                i < passwordScore
                  ? passwordScore === 1
                    ? 'bg-error'
                    : passwordScore === 2
                    ? 'bg-alert'
                    : passwordScore === 3
                    ? 'bg-warning'
                    : 'bg-success'
                  : 'bg-gray-200'
              }`}
            ></div>
          </div>
        ))}
      </div>
      <span className="text-caption font-regular text-neutral/100 ">
        {t('set-new-password.password-strength')}
      </span>
    </div>
  );
}

export default PasswordStrength;
